(function () {
  'use strict';

  console.debug('[semantic-url-variant-resolver] script loaded');

  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function init() {
    console.debug('[semantic-url-variant-resolver] initializing');

    var params = new URLSearchParams(window.location.search);

    // Skip if already has variant param or no params
    if (params.has('variant') || !params.toString()) {
      console.debug('[semantic-url-variant-resolver] skipping - no semantic params');
      return;
    }

    // Get product handle from URL
    var pathParts = window.location.pathname.split('/');
    var productHandle = pathParts[pathParts.length - 1];

    if (!productHandle) {
      console.debug('[semantic-url-variant-resolver] could not determine product handle');
      return;
    }

    console.debug('[semantic-url-variant-resolver] resolving variant for:', productHandle, 'with params:', Array.from(params.entries()));

    // Fetch product data
    fetch('/products/' + productHandle + '.json')
      .then(r => r.json())
      .then(data => {
        if (!data.product || !data.product.variants) {
          console.debug('[semantic-url-variant-resolver] no product or variants found');
          return;
        }

        var product = data.product;
        console.debug('[semantic-url-variant-resolver] product has', product.variants.length, 'variants');
        console.debug('[semantic-url-variant-resolver] product has options:', product.options);

        // Build map of slugified option names to indices
        var optionMap = {};
        if (Array.isArray(product.options)) {
          product.options.forEach(function (opt, idx) {
            var optName = (typeof opt === 'object' && opt.name) ? opt.name : opt;
            var sluggedName = slugify(optName);
            optionMap[sluggedName] = { name: optName, index: idx };
            console.debug('[semantic-url-variant-resolver] option[' + idx + ']:', optName, '(slugified:', sluggedName + ')');
          });
        }

        // Build target values from URL params
        var targetValues = {};
        var hasTargets = false;
        params.forEach(function (value, key) {
          if (optionMap[key]) {
            var idx = optionMap[key].index;
            targetValues[idx] = slugify(value);
            hasTargets = true;
            console.debug('[semantic-url-variant-resolver] looking for option[' + idx + '] = ' + value + ' (slugified: ' + targetValues[idx] + ')');
          }
        });

        if (!hasTargets) {
          console.debug('[semantic-url-variant-resolver] no matching options found in URL');
          return;
        }

        // Find matching variant
        var matchingVariant = product.variants.find(function (variant) {
          var options = [variant.option1, variant.option2, variant.option3];
          return Object.keys(targetValues).every(function (idx) {
            var variantValue = options[idx];
            var sluggedVariantValue = slugify(variantValue);
            var matches = sluggedVariantValue === targetValues[idx];
            console.debug('[semantic-url-variant-resolver]   variant.option' + (parseInt(idx) + 1) + ': ' + variantValue + ' (slugified: ' + sluggedVariantValue + ') matches: ' + matches);
            return matches;
          });
        });

        if (matchingVariant) {
          console.debug('[semantic-url-variant-resolver] ✓ found matching variant:', matchingVariant.id);

          // Try multiple methods to set the variant
          var variantSet = false;

          // Method 1: Find the variant input
          var variantInput = document.querySelector('input[name="id"].product-variant-id');
          if (variantInput) {
            console.debug('[semantic-url-variant-resolver] method 1: setting variant input to:', matchingVariant.id);
            variantInput.value = matchingVariant.id;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            variantSet = true;
          }

          // Method 2: Find any input with name="id"
          if (!variantSet) {
            var idInput = document.querySelector('input[name="id"]');
            if (idInput) {
              console.debug('[semantic-url-variant-resolver] method 2: found input[name="id"], setting to:', matchingVariant.id);
              idInput.value = matchingVariant.id;
              idInput.dispatchEvent(new Event('change', { bubbles: true }));
              variantSet = true;
            }
          }

          // Method 3: Update the URL with variant parameter
          if (!variantSet) {
            console.debug('[semantic-url-variant-resolver] method 3: updating URL with variant parameter');
            var newUrl = window.location.pathname + '?variant=' + matchingVariant.id;
            // Check if there were other params to preserve
            var otherParams = Array.from(params.entries()).filter(function(p) {
              return p[0] !== 'variant';
            });
            if (otherParams.length > 0) {
              newUrl += '&' + new URLSearchParams(otherParams).toString();
            }
            window.history.replaceState(null, '', newUrl);
            variantSet = true;
          }

          if (!variantSet) {
            console.debug('[semantic-url-variant-resolver] could not set variant - no suitable input found');
          }
        } else {
          console.debug('[semantic-url-variant-resolver] ✗ no matching variant found');
          // Log all available variants for debugging
          console.debug('[semantic-url-variant-resolver] available variants:');
          product.variants.forEach(function(v) {
            console.debug('[semantic-url-variant-resolver]   id:', v.id, 'option1:', v.option1, 'option2:', v.option2, 'option3:', v.option3);
          });
        }
      })
      .catch(e => {
        console.error('[semantic-url-variant-resolver] error:', e);
      });
  }

  // Run immediately and also on multiple events to ensure it runs
  console.debug('[semantic-url-variant-resolver] scheduling init');

  // Run with different delays to catch various states
  setTimeout(init, 100);
  setTimeout(init, 500);
  setTimeout(init, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      console.debug('[semantic-url-variant-resolver] DOMContentLoaded fired');
      setTimeout(init, 100);
    });
  }

  window.addEventListener('load', function () {
    console.debug('[semantic-url-variant-resolver] window load fired');
    setTimeout(init, 100);
  });
})();
